import { ContactType } from '@features/contacts/types/contactType'

import { DemoInvoiceCustomer } from '../types/demoInvoiceCustomer'

export const DEMO_INVOICE_CUSTOMERS: DemoInvoiceCustomer[] = [
  {
    cityText: 'Lyon',
    contactNo: '900001',
    countryId: 'FR',
    ean: '',
    email: 'contact@example.com',
    externalId: '900001',
    id: 'demo-customer-1',
    paymentTermsDays: 30,
    phone: '',
    registrationNo: '',
    street: '12 rue de la République',
    tName: 'demo_invoice.fixtures.customers.bakery',
    type: ContactType.Company,
    vatNo: '',
    zipcodeText: '69002',
  },
  {
    cityText: 'Nantes',
    contactNo: '900002',
    countryId: 'FR',
    ean: '',
    email: 'hello@example.com',
    externalId: '900002',
    id: 'demo-customer-2',
    paymentTermsDays: 15,
    phone: '',
    registrationNo: '',
    street: '4 quai de la Fosse',
    tName: 'demo_invoice.fixtures.customers.design_studio',
    type: ContactType.Company,
    vatNo: '',
    zipcodeText: '44000',
  },
  {
    cityText: 'Bordeaux',
    contactNo: '900003',
    countryId: 'FR',
    ean: '',
    email: 'client@example.com',
    externalId: '900003',
    id: 'demo-customer-3',
    paymentTermsDays: 30,
    phone: '',
    registrationNo: '',
    street: '8 cours de l’Intendance',
    tName: 'demo_invoice.fixtures.customers.private_client',
    type: ContactType.Person,
    vatNo: '',
    zipcodeText: '33000',
  },
]
